const translations = {
  en: {
    title: 'Most popular methods',
    min: 'Min',
    max: 'Max',
    noLimit: 'No Limit',
  },
  es: {
    title: 'Métodos más populares',
    min: 'Mín',
    max: 'Máx',
    noLimit: 'Sin Límite',
  },
  pt: {
    title: 'Métodos mais populares',
    min: 'Mín',
    max: 'Máx',
    noLimit: 'Sem Limite',
  },
}

export default translations
